import { GetQrCodeRequest, GetQrCodeResponse } from 'store/qr-codes/types';
import { createAction, createAsyncAction } from 'typesafe-actions';

import { FailureActionPayload } from 'store/errors/types';

export const getQrCode = createAsyncAction('GET_QR_CODE_REQUEST', 'GET_QR_CODE_SUCCESS', 'GET_QR_CODE_FAILURE')<
  GetQrCodeRequest,
  GetQrCodeResponse,
  FailureActionPayload
>();

export const clearQrCode = createAction('CLEAR_QR_CODE')<string>();
